var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.6,
    height: 122.5,
    viewBox: "0 0 92.6 122.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jpg_2_",
    "data-name": "jpg (2)",
    transform: "translate(-17.8 -2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M109,34v75a14.98,14.98,0,0,1-15,15H34a14.98,14.98,0,0,1-15-15V19A14.98,14.98,0,0,1,34,4H79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M94,125.2H34A16.2,16.2,0,0,1,17.8,109V19A16.133,16.133,0,0,1,34,2.8H79a1.222,1.222,0,0,1,.9.4l30,30a1.489,1.489,0,0,1,.4.9v75A16.261,16.261,0,0,1,94,125.2ZM34,5.2A13.828,13.828,0,0,0,20.2,19v90A13.828,13.828,0,0,0,34,122.8H94A13.828,13.828,0,0,0,107.8,109V34.5L78.5,5.2Z",
    fill: "#62355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M109,38V34L79,4H75V19A18.992,18.992,0,0,0,94,38Z",
    fill: "#62355c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M79,19A14.98,14.98,0,0,0,94,34h15L79,4Z",
    fill: "#62355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M109,35.2H94A16.2,16.2,0,0,1,77.8,19V4a1.3,1.3,0,0,1,.8-1.2,1.238,1.238,0,0,1,1.4.3l30,30a1.238,1.238,0,0,1,.3,1.4,1.709,1.709,0,0,1-1.3.7ZM80.2,7V19A13.828,13.828,0,0,0,94,32.8h12ZM44.4,69.6a1.89,1.89,0,0,1-2,2,1.944,1.944,0,0,1-2-2,1.866,1.866,0,0,1,2-1.9A1.923,1.923,0,0,1,44.4,69.6Z",
    fill: "#62355c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "file",
    transform: "translate(45.8 76.7)",
    fill: "#62355c",
    fontSize: 33,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "file")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.aa939cea93349f5bbcb3ab869459804a.svg";
export { ForwardRef as ReactComponent };